export const GET_TAG = {
    BEGIN: 'personalizationTypes/GET_TAG_BEGIN',
    SUCCESS: 'personalizationTypes/GET_TAG_SUCCESS',
    ERROR: 'personalizationTypes/GET_TAG_ERROR',
};

export const SET_TAG = {
    BEGIN: 'personalizationTypes/SET_TAG_BEGIN',
    SUCCESS: 'personalizationTypes/SET_TAG_SUCCESS',
    ERROR: 'personalizationTypes/SET_TAG_ERROR',
};

export const UPDATE_TAG = 'personalizationTypes/UPDATE_TAG';

export const GET_SINGLE_USE_TAGS = {
    BEGIN: 'personalizationTypes/GET_SINGLE_USE_TAGS_BEGIN',
    SUCCESS: 'personalizationTypes/GET_SINGLE_USE_TAGS_SUCCESS',
    ERROR: 'personalizationTypes/GET_SINGLE_USE_TAGS_ERROR',
};

export const SET_INVALID_TAGS = 'personalizationTypes/SET_INVALID_TAGS';
export const CLEAR_ERRORS = 'personalizationTypes/CLEAR_ERRORS';
